module.exports = __webpack_public_path__ + "img/GLOBAL_WHOLE_GRAINS.59519003.png";